module.exports = __webpack_public_path__ + "static/media/bussines_unit.f9ee0571.png";